// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0f1cf8aa","453":"3154de31","732":"46dbc5a8"}[chunkId] + ".chunk.js";
};